export type WorkspaceItems  = any[];

export enum WorkspaceTabType {
    WorkflowRuns = "workflowRuns",
    SearchRuns = "searchRuns",
    ActionRuns = "actionRuns",
    Approvals = "approvals"
}
